import * as R from 'ramda';

interface NetworkErrorInfo {
  message: string;
  messageParameters: any[];
  type: {
    level: string;
    message: string;
    name: string;
  };
}

interface NetworkError {
  error: NetworkErrorInfo;
  message: string;
  ok: boolean;
  status: number;
  statusText: string;
  url: string;
}

export interface AppError {
  extraInfo: any;
  graphQLErrors: any[];
  message: string;
  networkError: NetworkError;
}

type GetNetworkError = (appError: AppError) => NetworkError;
const getNetworkError = <GetNetworkError> R.propOr({}, 'networkError');

type GetNetworkErrorInfo = (appError: AppError) => NetworkErrorInfo;
const getNetworkErrorInfo = <GetNetworkErrorInfo>R.compose(R.propOr({}, 'error'), getNetworkError);

type GetNetworkErrorLevel = (appError: AppError) => string;
const getNetworkErrorLevel = <GetNetworkErrorLevel>R.compose(R.path(['type', 'level']), getNetworkErrorInfo);

type IsErrorLevelActionRequired = (appError: AppError) => boolean;
export const actionRequired = <IsErrorLevelActionRequired>R.compose(R.equals('ACTION_REQUIRED'), getNetworkErrorLevel);

type IsErrorLevelConfirmationRequired = (appError: AppError) => boolean;
export const confirmationRequired: IsErrorLevelConfirmationRequired = <IsErrorLevelActionRequired>R.compose(R.equals('CONFIRMATION_REQUIRED'), getNetworkErrorLevel);

type GetConfirmationMessage = (appError: AppError) => string;
export const getConfirmationMessage = <GetConfirmationMessage>R.compose(R.path(['type', 'message']), getNetworkErrorInfo);
